(function () {

  const CACHE_KEY = "pixel_attribution_last_payload";

  function getCookie(name) {
    return document.cookie
      .split('; ')
      .find(c => c.startsWith(name + '='))
      ?.split('=')
      .slice(1)
      .join('=') || null;
  }

  function estimateTimestampFromExpiry(days) {
    return Math.floor(Date.now() / 1000) - (days * 86400);
  }

  async function getCart() {
    try {
      const res = await fetch('/cart.js?_=' + Date.now(), { cache: "no-store" });
      return res.ok ? await res.json() : null;
    } catch {
      return null;
    }
  }

  async function updateCartAttributes(attrs) {
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  function isSamePayload(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
  }

  async function capturePixelDataToCart() {
    const cart = await getCart();
    if (!cart || !cart.token) return;

    const attrs = {};
    const now = Math.floor(Date.now() / 1000);

    /* ---------- CART TOKEN (for checkout extension) ---------- */
    if (window.globalCartTokenPushEnabled) {
      attrs._cart_token_push = cart.token;
    }

    /* ---------- GOOGLE ---------- */
    const gcl_aw = getCookie('_gcl_aw');
    if (gcl_aw) {
      const ts = Number(gcl_aw.split('.')[1]) || now;
      attrs.attr_google_gcl_aw = gcl_aw;
      attrs.attr_google_ts = ts;
    }

    /* ---------- FACEBOOK (fbc2) ---------- */
    // const fbc2 = getCookie('_fbc2');
    // if (fbc2) {
    //   const ts = Number(fbc2.split('.')[2]) || now;
    //   // attrs.attr_facebook_fbc2 = fbc2;
    //   attrs.attr_facebook_fbc = fbc2;
    //   attrs.attr_facebook_ts = ts;
    // }

    const fbc = getCookie('_fbc');
    if (fbc) {
      const ts = Number(fbc.split('.')[2]) || now;
      attrs.attr_facebook_fbc = fbc;
      attrs.attr_facebook_ts = ts;
    }

    /* ---------- TIKTOK ---------- */
    const ttclid = getCookie('ttclid');
    if (ttclid) {
      attrs.attr_tiktok_ttclid = ttclid;
      attrs.attr_tiktok_ts = estimateTimestampFromExpiry(395);
    }

    /* ---------- SNAPCHAT ---------- */
    const scclid = getCookie('scclid');
    if (scclid) {
      attrs.attr_snapchat_scclid = scclid;
      attrs.attr_snapchat_ts = estimateTimestampFromExpiry(395);
    }

    if (!Object.keys(attrs).length) {
      console.log("📦 Final Pixel Attribution Payload: {} (nothing to save)");
      return;
    }

    /* ---- 1. SESSION STORAGE BLOCK ---- */
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached && isSamePayload(JSON.parse(cached), attrs)) {
      console.log("📦 Final Pixel Attribution Payload: no change, skipped update");
      return;
    }

    /* ---- 2. CART ATTRIBUTE BLOCK ---- */
    const existing = cart.attributes || {};
    let changed = false;

    for (const k in attrs) {
      if ((existing[k] || "") !== String(attrs[k])) {
        changed = true;
        break;
      }
    }

    if (!changed) {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(attrs));
      console.log("📦 Final Pixel Attribution Payload: no change, skipped update");
      return;
    }

    /* ---- 3. UPDATE ---- */
    console.log("📦 Final Pixel Attribution Payload:", attrs);
    await updateCartAttributes(attrs);
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(attrs));
  }

  capturePixelDataToCart();

})();